// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.framesdata.UpdateFramesDataSubscriptionRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateFramesDataSubscriptionRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Subscriber Billing Zip Code is required' } })
	@GandalfValidator({ sizeString: { message: 'Subscriber Billing Zip Code must be between 1 and 20 characters', minLength: 1, maxLength: 20 } })
	@GandalfProperty({ designType: String, isRequired: true })
	billingPostalCode!: string;

	@GandalfValidator({ notNull: { message: '{jakarta.validation.constraints.NotNull.message}' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfValidator({ notNull: { message: 'Contact is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	internalContactEmployeeId!: number;

	@GandalfValidator({ notNull: { message: 'Number of Locations is required' } })
	@GandalfValidator({ min: { min: 1, message: 'Number of Locations must be greater than 0' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	numberOfLocations!: number;

	@GandalfValidator({ notNull: { message: 'Subscriber Shipping Zip Code is required' } })
	@GandalfValidator({ sizeString: { message: 'Subscriber Shipping Zip Code must be between 1 and 20 characters', minLength: 1, maxLength: 20 } })
	@GandalfProperty({ designType: String, isRequired: true })
	shippingPostalCode!: string;

	@GandalfValidator({ notNull: { message: 'Subscriber Username is required' } })
	@GandalfValidator({ sizeString: { message: 'Subscriber Username must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	username!: string;

	@GandalfValidator({ notNull: { message: '{jakarta.validation.constraints.NotNull.message}' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	version!: number;

}
